import { useData } from '../contexts/index';
import { useDataSync } from './useDataSync';

/**
 * Subscribes to a role overview collection via the data adapter.
 */
export function useRoleCollection<T>(
  collection: string,
  initialValue: T,
): T {
  const { adapter } = useData();
  return useDataSync<T>(adapter, collection, initialValue);
}
